<script>
    import {store} from '../stores.js';
    import storage from '../storage.js';

    const user = store('credential', 'getAuth');
    const year = (new Date()).getFullYear();

    const logout = () => {
        user.remove();
        storage.clear();
        location.href = '/';
    };
</script>

<!-- App about -->
<div class="section full mt-2">
    <img src="/img/logo.png" alt="image" class="imaged square d-block mx-auto" style="width: 100%;max-width: 200px;height: auto;">
</div>

<div class="section full mt-2" style="font-size: 11px; line-height: 1.2em;">
    <div class="text-center text-muted">
        v{APP_VERSION} (build: {COMMIT_SHA})<br>[type: {APP_TYPE}]
    </div>
</div>

<div class="section full mt-2">
    <div class="section-title">О нас</div>
    <div class="wide-block pt-2 pb-1">

        <p>
            Название нашей компании выбрано неслучайно. <b>Командир </b>– это не просто юридическое решение, а стратегический маневр, позволяющий добиваться успеха там, где другие видят тупик.
            В основе стратагем лежит мудрость тысячелетий и искусство побеждать без войны. Эти принципы использовались в древнекитайской и греческой стратегиях, помогая выигрывать не силой, а расчетом, гибкостью и дальновидностью. Мы применяем этот подход в юридической практике:

            ✅ Анализируем ситуацию шире, чем стандартные юридические подходы
            ✅ Предугадываем шаги оппонентов и находим нестандартные решения
            ✅ Управляем процессом так, чтобы достичь успеха с минимальными рисками для вас
        </p>
    </div>
</div>

<div class="section full mt-2 mb-5" style="font-size: 11px; line-height: 1.2em;">
    <div class="text-center">
        <div class="row">
            <div class="col-6">
                {#if $user.id > 0}<div on:click={logout}>{$user.name}<br>{$user.email} [{$user.id}]</div>{/if}
            </div>
            <div class="col-6">
                Copyright © {(new Date).getFullYear()}<br><a href="https://u4et.ru" target="_blank">u4et.ru</a>
            </div>
        </div>
    
    </div>
</div>
<!-- * App about -->
